import React from 'react';
import { Icon } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { OptionsSection, Option, Copyright, Social } from './MenuStyles';
import SubMenuComponent from './SubMenuComponent';
import Transition from 'react-transition-group/Transition';

class MenuOptions extends React.Component {
  state = {
    hovered: null,
    openSub: false,
    onSub: false
  };

  OnOptionHover = option => {
    this.setState({ hovered: option, openSub: false });
  };

  handleSubMenu = () => {
    const { onSub } = this.state;
    const sub = onSub;
    this.setState({ hovered: null, openSub: sub });
  };

  navigate = link => {
    const { history, onClose } = this.props;
    this.setState({ hovered: null, openSub: null, onSub: false }, () => {
      onClose();
      setTimeout(() => history.push(link), 100);
    });
  };

  render() {
    const { show, contact } = this.props;
    const { hovered, openSub } = this.state;
    return (
      <Transition
        timeout={{ enter: 0, exit: 200 }}
        in={show}
        unmountOnExit
        mountOnEnter
      >
        {state => (
          <OptionsSection state={state}>
            <Option
              active={hovered == null || hovered === 'about'}
              onMouseEnter={() =>
                this.setState({ hovered: 'about', openSub: true })
              }
              onMouseLeave={this.handleSubMenu}
            >
              About Us
              <SubMenuComponent
                navigate={this.navigate}
                show={openSub}
                onMouseEnter={() => this.setState({ onSub: true })}
                onMouseLeave={() =>
                  this.setState({ onSub: false, openSub: false })
                }
              />
            </Option>
            <Option
              onClick={() => this.navigate('/news')}
              active={hovered == null || hovered === 'news'}
              onMouseEnter={() => this.OnOptionHover('news')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              News
            </Option>
            <Option
              onClick={() => this.navigate('/events')}
              active={hovered == null || hovered === 'events'}
              onMouseEnter={() => this.OnOptionHover('events')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              Events
            </Option>
            <Option
              onClick={() => this.navigate('/publications')}
              active={hovered == null || hovered === 'publications'}
              onMouseEnter={() => this.OnOptionHover('publications')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              Publications
            </Option>
            <Option
              onClick={() => this.navigate('/education')}
              active={hovered == null || hovered === 'education'}
              onMouseEnter={() => this.OnOptionHover('education')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              EFRS Research HUB
            </Option>
            <Option
              onClick={() => this.navigate('/cpd')}
              active={hovered == null || hovered === 'cpd'}
              onMouseEnter={() => this.OnOptionHover('cpd')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              Radiography CPD & Research
            </Option>
            <Option
              onClick={() => this.navigate('/rrn')}
              active={hovered == null || hovered === 'rrn'}
              onMouseEnter={() => this.OnOptionHover('rrn')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              RRN & Radiography Journal
            </Option>
            <Option
              onClick={() => this.navigate('/educational-wing')}
              active={hovered == null || hovered === 'educational_wing'}
              onMouseEnter={() => this.OnOptionHover('educational_wing')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              EFRS Educational Wing
            </Option>
            <Option
              onClick={() => this.navigate('/webinars')}
              active={hovered == null || hovered === 'webinars'}
              onMouseEnter={() => this.OnOptionHover('webinars')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              EFRS Webinars
            </Option>
            <Option
              onClick={() => this.navigate('/broadcast')}
              active={hovered == null || hovered === 'broadcast'}
              onMouseEnter={() => this.OnOptionHover('broadcast')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              Advertising
            </Option>
            <Option
              onClick={() => this.navigate('/links')}
              active={hovered == null || hovered === 'links'}
              onMouseEnter={() => this.OnOptionHover('links')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              Links
            </Option>
            <Option
              onClick={() => this.navigate('/contact')}
              active={hovered == null || hovered === 'contact'}
              onMouseEnter={() => this.OnOptionHover('contact')}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              Contact
            </Option>
            <Option
              onClick={() => this.navigate('/terms')}
              active={hovered == null || hovered === 'terms'}
              onMouseEnter={() => this.OnOptionHover('terms')}
              onMouseLeave={() => this.setState({ hovered: null })}
              smaller
            >
              Terms & Conditions
            </Option>

            <Copyright>
              &copy; 2018 efrs | Powered by{' '}
              <a
                href="https://setima.pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sétima
              </a>
            </Copyright>
            <Social>
              <Icon
                type="twitter"
                theme="outlined"
                onClick={() => window.open(contact.twitter, '_blank')}
              />
              <Icon
                type="facebook"
                theme="filled"
                onClick={() => window.open(contact.facebook, '_blank')}
              />
              <Icon
                type="instagram"
                theme="filled"
                onClick={() => window.open(contact.instagram, '_blank')}
              />
            </Social>
          </OptionsSection>
        )}
      </Transition>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  contact: state.info.contact
});

export default withRouter(connect(mapStateToProps)(MenuOptions));



// WEBPACK FOOTER //
// ./src/components/Menu/MenuOptions.js